import { gql } from '@apollo/client';

export const ALL_DISTRICTS = gql`
  query AllDistricts($input: DistrictInput!) {
    districts: getDistricts(input: $input) {
      id
      name
    }
  }
`;
